module.exports = __webpack_public_path__ + "media/media/service/experience-8994a17b9a6a118f25f62dd95cfcbb8c.png";